<template>
  <div class="order-page-buttons" :class="{ visible }">
    <div class="buttons c:row-center" ref="container">
      <template v-if="isAreaManagerAccount || isStoreManagerAccount">
        <CButton
          v-if="canRefund"
          :loading="submiting"
          @click="onApplyRefundButtonClick"
          >申请退款</CButton
        ></template
      >
      <template v-else-if="isCreator">
        <template v-if="isBaseOrder">
          <div v-if="order.status === 30" class="order-ship-button">
            <div class="order-ship-option c:col-between-start">
              <div class="order-ship-option-checkboxes c:row-start-center">
                <van-checkbox
                  v-model="isUrgent"
                  shape="square"
                  class="order-ship-option-checkbox"
                  >物流加急</van-checkbox
                >
                <van-checkbox
                  v-if="this.brandInfo.extra.shippingInsuranceEnabled || true"
                  v-model="isQuote"
                  shape="square"
                  class="order-ship-option-checkbox"
                  >是否保价</van-checkbox
                >
              </div>
              <span
                class="order-ship-tips"
                v-if="this.brandInfo.extra.logisticsOptionText"
                >{{ this.brandInfo.extra.logisticsOptionText }}</span
              >
            </div>
            <CButton primary :loading="submiting" @click="onShipButtonClick"
              >发货</CButton
            >
          </div>
          <CButton
            v-else-if="order.status === 40"
            primary
            :loading="submiting"
            @click="onScanButtonClick"
            >面对面发货</CButton
          >
          <CButton
            v-else-if="isStatusSent && !isSendOff"
            :loading="submiting"
            @click="onCancelShippingButtonClick"
            >取消发货</CButton
          >
        </template>
        <CButton
          v-else-if="order.status === 80"
          primary
          :loading="submiting"
          @click="onCompleteOrderButtonClick"
          >完成订单</CButton
        >
      </template>
    </div>
    <CBottomPad />
  </div>
</template>

<script>
  import { getWxWorkRouteInfo } from '@/api'
  import CBottomPad from '@/components/common/CBottomPad.vue'
  import CButton from '@/components/common/CButton.vue'
  import { mapGetters, mapState } from 'vuex'

  export default {
    components: { CButton, CBottomPad },
    props: {
      order: Object,
      isCreator: Boolean,
      isBaseOrder: Boolean,
      isStatusSent: Boolean,
      isSendOff: Boolean,
      submiting: Boolean,
      canRefund: Boolean,
      paymentPrivacyChecked: Boolean
    },
    data() {
      return {
        visible: false,
        isUrgent: false,
        isQuote: false
      }
    },
    computed: {
      ...mapState(['brandInfo']),
      ...mapGetters(['isStoreManagerAccount', 'isAreaManagerAccount'])
    },
    watch: {
      'order.status': {
        deep: true,
        immediate: true,
        handler() {
          // console.log("watch order.status", this.order.status, this.isStatusSent);
          if (this.isCreator && this.isStatusSent) {
            this.visible = false
            this.$emit('update:is-send-off', true)
            if (this.order.status === 50) {
              this.checkCancelable()
            }
          } else {
            this.$nextTick().then(() => this.checkVisibility())
          }
        }
      },
      isSendOff: {
        handler() {
          // console.log('watch isSendOff', this.isStatusSent, !this.isSendOff);
          this.$nextTick().then(() => this.checkVisibility())
        }
      }
    },
    mounted() {
      this.checkVisibility()
    },
    methods: {
      async checkCancelable() {
        this.$toast.loading({
          message: '获取物流状态',
          forbidClick: true
        })
        try {
          let isSendOff = true
          const res = await getWxWorkRouteInfo(this.order.id)
          console.log('checkCancelable res', res)
          if (res?.[0]) {
            isSendOff = res[0].logisticsRouteInfoList.some(
              route => route.status === 'SEND_OFF'
            )
          } else {
            isSendOff = false
          }
          this.$emit('update:is-send-off', isSendOff)
          this.visible = !isSendOff
          this.$toast.clear()
        } catch (error) {
          console.log('checkCancelable error', error)
          this.$emit('update:is-send-off', false)
          this.visible = true
          if (error?.message) this.$toast(error.message)
          else this.$toast.clear()
        }
      },
      checkVisibility() {
        // console.log(this.$refs.container && this.$refs.container.innerHTML);
        if (this.$refs.container && this.$refs.container.innerHTML) {
          this.visible = this.$refs.container.innerHTML.includes('<div')
        } else {
          this.visible = false
        }
      },
      onApplyRefundButtonClick() {
        this.$emit('applyrefund')
      },
      onShipButtonClick() {
        this.$emit('ship', { isUrgent: this.isUrgent, isQuote: this.isQuote })
      },
      onScanButtonClick() {
        this.$emit('scan')
      },
      onCancelShippingButtonClick() {
        this.$emit('cancelshipping')
      },
      onCompleteOrderButtonClick() {
        this.$emit('complete')
      }
    }
  }
</script>

<style lang="less" scoped>
  .order-page-buttons {
    position: fixed;
    width: 100%;
    height: auto;
    bottom: 0;
    z-index: 200;

    &.visible {
      background-color: #fff;
      box-shadow: 0px -2px 5px 0px #00000017;
    }

    .buttons {
      gap: 12/20rem;

      box-sizing: border-box;
      padding: 8/20rem 20/20rem;
    }

    .order-ship-button {
      width: 100%;
      .order-ship-option {
        gap: 10/20rem;

        margin: 2/20rem 0 10/20rem;
        line-height: 17/20rem;
        font-size: 12/20rem;
        font-weight: 400;
        letter-spacing: 0;
        color: #7d7d7d;
      }
    }
  }
</style>
<style lang="less">
  .order-page-buttons {
    box-sizing: border-box;
    .order-ship-button {
      .order-ship-option {
        .order-ship-option-checkbox {
          & + .order-ship-option-checkbox {
            margin-left: 16/20rem;
          }
          line-height: 17/20rem;
          font-size: 12/20rem;
          font-weight: 400;
          letter-spacing: 0;
          text-align: right;
          color: #7d7d7d;
        }
      }
    }
  }
</style>
